import React from "react";
import { useEffect, useRef } from "react";

export const VideoComponent: React.FC<{ videoSrc: string }> = ({ videoSrc }) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
  
    useEffect(() => {
      return () => {
        // Cleanup function to pause the video and release resources
        if (videoRef.current) {
          videoRef.current.pause();
          videoRef.current.src = ""; // Unset the src to stop downloading
        }
      };
    }, []);
  
    return (
      <video ref={videoRef} controls autoPlay muted loop>
        <source src={videoSrc} type="video/mp4" />
      </video>
    );
  };